module.exports = __webpack_public_path__ + "img/recruit_cont06_img02.891a4a63.png";